import "../shared/shared";
import "../controllers/users";

import morphdom from "morphdom";
import reconnectControllers from "../shared/reconnect_controllers";
import closeOpenDialogs from "../shared/close_open_dialogs";
import keepScrollOnSubmit from "../shared/keep_scroll_on_submit";
import {
  morphCustomerPage,
  rememberRenderedAnswers,
} from "../shared/customer_morph";

// What the server answered for the page as parsed,
// written down before any controller can rewrite it:
// the morph compares a select with THIS, because
// `state-selector` and `city-selector` rebuild their
// option lists and the server's `selected` mark goes
// with them. Stimulus connects after `domReady()`, a
// promise that settles only once this module has run, so
// the synchronous branch is ahead of it. On a document
// still loading, the capture listener on `window` runs
// ahead of Stimulus's own on `document`.
if (document.readyState === "loading") {
  window.addEventListener(
    "DOMContentLoaded",
    () => rememberRenderedAnswers(document.body),
    { capture: true, once: true }
  );
} else {
  rememberRenderedAnswers(document.body);
}

let prevPath = window.location.pathname;

window.scrolled = false;
// Stimulus controllers can set this flag to skip scroll to top after morph.
window.temporarySkipScrollAfterMorph = false;

// The discount code's Apply and Remove redraw the page
// they were pressed on and keep the customer's place.
keepScrollOnSubmit(document);

document.addEventListener("turbo:load", () => {
  window.scrolled = false;
  window.temporarySkipScrollAfterMorph = false;
});

document.addEventListener("turbo:before-render", (event) => {
  if (Turbo.navigator.currentVisit) {
    Turbo.navigator.currentVisit.scrolled =
      prevPath === window.location.pathname;
  }
  prevPath = window.location.pathname;

  event.detail.render = async (prevEl, newEl) => {
    await new Promise((resolve) => setTimeout(() => resolve(), 0));
    // What survives this morph, typed checkout values
    // and radio picks included, is decided in
    // `shared/customer_morph`.
    morphCustomerPage(prevEl, newEl);

    reconnectControllers(Stimulus.controllers);

    if (document.querySelector("meta[name='keep-scroll-after-morph']")) {
      // console.log("Keep scroll after morph");
      return;
    }

    if (window.scrolled) {
      // console.log("Scrolled skip");
      return;
    }

    if (window.temporarySkipScrollAfterMorph) {
      // console.log("Temporary skip scroll");
      window.temporarySkipScrollAfterMorph = false;
      return;
    }

    // console.log("Scroll to top after morph");
    document.querySelector("main").scrollTo({
      top: 0,
      behavior: "instant",
    });

    window.scrolled = true;
  };
});

document.addEventListener("turbo:before-frame-render", (event) => {
  event.detail.render = (prevEl, newEl) => {
    morphdom(prevEl, newEl, {
      childrenOnly: true,
    });

    reconnectControllers(Stimulus.controllers);
  };
});

// So that morphing doesn't leave open dialogs, we close them before the render.
document.addEventListener("turbo:before-render", () => {
  closeOpenDialogs();
});
